import React from "react";
import { withTranslation } from "react-i18next";

import Button from "../../../../components/UI/Button/Button";

import classes from "./AddressAlert.module.css";

interface Props {
  goBackHandler:()=>void;
  modalClosed: () => void;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  city: string;
  state: string;
  postalCode: string;
  addressConfirmed: () => void;
  t:any;
}

const contactAlert: React.FunctionComponent<Props> = (props) => {
  const {
    goBackHandler,
    modalClosed,
    addressLine1,
    addressLine2,
    addressLine3,
    city,
    state,
    postalCode,
    addressConfirmed,
  } = { ...props };

  const nextBtnStyle = {
    minWidth: "110px",
    height: "35px",
  };

  
  return (
  
    
    <div className={classes.popupBody}>
      {/* <div className={classes.closeBtn} onClick={modalClosed}>
        X
      </div> */}
      <h6 className="popup-title">{props.t('address.confirmAddress')}</h6>
      <div>
        <h5 className="popup-text">
          {addressLine1 && addressLine1}
          {addressLine1 && <br />}
          {addressLine2 && addressLine2}
          {addressLine2 && <br />}
          {addressLine3 && addressLine3}
          {addressLine3 && <br />}
          {city} <br />
          {state} <br />
          {postalCode} <br />
          {/* {addressText1} */}
        </h5>
      </div>
      <div className="alert-buttons">
        <Button
          label={props.t('balanceBilling.backBtn')}
          clicked={goBackHandler}
          style={nextBtnStyle}
          displayImg={false}
          image=""
          disabled={false}
        />
        <Button
          label={props.t('address.UpdateAddress')}
          clicked={modalClosed}
          style={nextBtnStyle}
          displayImg={false}
          image=""
          disabled={false}
        />
        <Button
          label={props.t('feedBack.confirm')}
          clicked={addressConfirmed}
          style={nextBtnStyle}
          displayImg={false}
          image=""
          disabled={false}
        />
      </div>
    </div>
  );
};
export default withTranslation()(contactAlert);
